@if ((loaded$ | async) == true) {
  <form [formGroup]="consentDeclarationForm" data-testid="translate" class="consent">
    <h1 data-testid="title" [attr.color]="TRANSLATE_PATH_SHARED.COLOR_REDIRECT | translate ">{{TRANSLATE_PATH_PROJECT.IDENTIFICATION_TITLE | translate}}</h1>
    @if (sMergeQuestiondata.subtitle) {
      <h2 data-testid="subtitle1">{{sMergeQuestiondata.subtitle}}</h2>
    }
    <div>
      <app-user-data [id]="id" formControlName="userdata" ngDefaultControl></app-user-data>
    </div>
    <div>
      <app-bankamount [id]="id" formControlName="bankamount" ngDefaultControl></app-bankamount>
    </div>
    <div>
      <app-question-item-list [id]="id" formControlName="questionItemList" ngDefaultControl></app-question-item-list>
    </div>
    <div class="button-continue">
      <button data-testid="button" (click)="onClickSubmit()" mat-raised-button [color]="TRANSLATE_PATH_SHARED.COLOR_REDIRECT | translate" type="submit" [disabled]="!consentDeclarationForm.valid || consentDeclarationForm.untouched">{{TRANSLATE_PATH_PROJECT.CONSENT_DECLARATION_BUTTON | translate}}</button>
    </div>
  </form>
}

@if (sSpinner.enabled) {
  <app-spinner></app-spinner>
}
